export const RESET = 'EXCMAGREEMENTTYPE_UPDATE_RESET'
export const SET_ERROR = 'EXCMAGREEMENTTYPE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMAGREEMENTTYPE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMAGREEMENTTYPE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMAGREEMENTTYPE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMAGREEMENTTYPE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMAGREEMENTTYPE_UPDATE_UPDATE_RETRIEVED'
